const toastrFileDownBtn = {
  info1: '¡Espere!',
  info2: 'Se está generando su documento',
  error1: '¡Error!',
  error2: 'No se pudo descargar el informe. ¡Inténtelo de nuevo!'
};

export default toastrFileDownBtn;
